import LetterAvatar from "@/components/Avatar/LetterAvatar"
import DetailAvatar from "@/components/Avatar/DetailAvatar"
import StatusBadge from "@/components/ui/badge"
import CodeFormat from "@/components/ui/code"
import { formatToDevanagariStyle } from "@/utilities/helper"
export const columns = [
  {
    header: "Code",
    cell: ({ row }) => (
      <div className="whitespace-nowrap">
        <CodeFormat value={row.original.code} />
      </div>
    ),
  },
  {
    header: "Sales Date",
    cell: ({ row }) => (
      <span className="whitespace-nowrap">{row.original.date}</span>
    ),
  },
  {
    header: "Sales Date Nepali",
    cell: ({ row }) => (
      <span className="whitespace-nowrap">{row.original.date_nepali}</span>
    ),
  },
  {
    header: "Total Amount",
    cell: ({ row }) => (
      <div className="whitespace-nowrap">
        Rs. {formatToDevanagariStyle(row.original.total_return_amount)}
      </div>
    ),
  },
]
